/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Order/Content/Name"
  
}) {
let orderTitleValueData = fromData.useDataValue({ viewPath,
context: 'order',
path: 'title',
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="order.title"
 text={orderTitleValueData}
 weight="medium"
 size="large"
/>
{children}
</React.Fragment>)
}